var map = {
	"./en/404.json": 8918,
	"./en/common.json": 2623,
	"./en/fullscreen.json": 755,
	"./en/home.json": 6797,
	"./en/nav-menu.json": 3269,
	"./en/search.json": 2114,
	"./pl/404.json": 6513,
	"./pl/common.json": 9442,
	"./pl/fullscreen.json": 4274,
	"./pl/home.json": 7164,
	"./pl/nav-menu.json": 3640,
	"./pl/search.json": 1911
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2009;